export default __webpack_public_path__ + "static/media/image.687c7cee.svg";